import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var searchFieldInput = 'fx_2d2fb1e5_1yx5y5q8';
var searchFieldRoot = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_1yx5y5q0',variantClassNames:{disabled:{true:'fx_2d2fb1e5_1yx5y5q1',false:'fx_2d2fb1e5_1yx5y5q2'}},defaultVariants:{disabled:false},compoundVariants:[]});
var searchFieldRootVariants = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_1yx5y5q3',variantClassNames:{state:{'default':'fx_2d2fb1e5_1yx5y5q4',error:'fx_2d2fb1e5_1yx5y5q5'},variant:{outline:'fx_2d2fb1e5_1yx5y5q6',solid:'fx_2d2fb1e5_1yx5y5q7'}},defaultVariants:{state:'default',variant:'solid'},compoundVariants:[]});

export { searchFieldInput, searchFieldRoot, searchFieldRootVariants };
//# sourceMappingURL=searchField.vanilla.mjs.map
